import { Outlet } from "react-router-dom";
import Header from "./Header/Header";
import { useState } from "react";
import VerticalMenuSuperAdmin from "./LeftMenu/VerticalMenuSuperAdmin";

const Main = () => {
  return (
    <>
      <Header />
      <div id="main-app" className="layout-veritcle-menu">
        <VerticalMenuSuperAdmin/>
        <div className="app-body ">
          <Outlet/>
        </div>
      </div>
    </>
  );
};

export default Main;
